import React from 'react'
import { Table } from "@q4us-sw/q4us-ui";
import {getFeConfig,visualize} from "../api/api";
import {PageHeader, Button, Space} from "antd";

export const HS6PSubcontractorInfo = (props)=>{

    return <React.Fragment>
        <PageHeader title="HS6+ Subcontractors"/>
        <Table
            fetchConfig={async ()=>{
                const {data= {}} = await getFeConfig("hs6p_subcontractor")
                const { statusCode, rows = [], fields = [] } = data;
                return {data:{statusCode, rows, fields}};
            }}
            fetchData={async ()=>{
                return await visualize("hs6p_subcontractor")
            }}
            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}

            editable={false}

            source={{
                container: [],
                columns: [],
                action: "config",
                edit: {}
            }}
        />
    </React.Fragment>
}